// ========================================
// COMPREHENSIVE VALIDATION PATTERNS
// ========================================

export const pattern = {
    // ========================================
    // CONTACT INFORMATION
    // ========================================
    mobile: {
        value: /^[1-9]{1}[0-9]{9}$/,  // Updated: Indian mobile starts with 6,7,8,9
        message: 'Enter valid 10 digit mobile number starting with 6,7,8 or 9'
    },
    
    email: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: 'Enter a valid email address'
    },
    
    // ========================================
    // PAYMENT & FINANCIAL
    // ========================================
    upiId: {
        value: /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/,
        message: 'Enter a valid UPI ID (e.g., user@paytm)'
    },
    
    panNumber: {
        value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: 'Enter valid PAN number (e.g., ABCDE1234F)'
    },
    
    aadharNumber: {
        value: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
        message: 'Enter valid 12 digit Aadhaar number'
    },
    
    gstNumber: {
        value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        message: 'Enter valid 15 digit GST number'
    },
    
    // ========================================
    // BANKING INFORMATION
    // ========================================
    bankName: {
        value: /^[A-Za-z0-9\s\.\-\&\(\)\,\']{2,100}$/,
        message: 'Enter a valid bank name (2-100 characters)'
    },
    
    bankAccountNumber: {
        value: /^[0-9]{9,18}$/,  // Updated: Most Indian banks use 9-18 digits
        message: 'Enter valid account number (9-18 digits)'
    },
    
    bankIfscCode: {
        value: /^[A-Z]{4}0[A-Z0-9]{6}$/,  // Updated: 5th character is always 0
        message: 'Enter valid IFSC code (e.g., SBIN0001234)'
    },
    
    // ========================================
    // PERSONAL INFORMATION
    // ========================================
    personalName: {
        value: /^[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\s'-]{2,50}$/,
        message: 'Enter valid name (2-50 characters, letters only)'
    },
    
    businessName: {
        value: /^[a-zA-Z0-9\s'.-_&$()#@!]{2,100}$/,
        message: 'Enter valid business name (2-100 characters)'
    },
    
    generalName: {
        value: /^[a-zA-Z0-9][a-zA-Z0-9\s'.-_&$()#@!]*[a-zA-Z0-9.]?$/,
        message: 'Enter valid name or business name'
    },
    
    // ========================================
    // ADDRESS INFORMATION
    // ========================================
    pincode: {
        value: /^[1-9][0-9]{5}$/,  // Indian pincode
        message: 'Enter valid 6 digit pincode'
    },
    
    address: {
        value: /^[a-zA-Z0-9\s\.\,\-\#\/\(\)]{5,200}$/,
        message: 'Enter valid address (5-200 characters)'
    },
    
    // ========================================
    // IDENTIFICATION NUMBERS
    // ========================================
    voterIdNumber: {
        value: /^[A-Z]{3}[0-9]{7}$/,  // Indian Voter ID
        message: 'Enter valid Voter ID (e.g., ABC1234567)'
    },
    
    drivingLicense: {
        value: /^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/,  // Indian Driving License
        message: 'Enter valid Driving License number'
    },
    
    passportNumber: {
        value: /^[A-Z]{1}[0-9]{7}$/,  // Indian Passport
        message: 'Enter valid Passport number (e.g., A1234567)'
    },
    
    // ========================================
    // BUSINESS IDENTIFIERS
    // ========================================
    cinNumber: {
        value: /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,  // Corporate Identity Number
        message: 'Enter valid CIN number'
    },
    
    tanNumber: {
        value: /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/,  // Tax Account Number
        message: 'Enter valid TAN number (e.g., ABCD12345E)'
    },
    
    // ========================================
    // NUMERIC VALIDATIONS
    // ========================================
    positiveNumber: {
        value: /^[1-9][0-9]*$/,
        message: 'Enter valid positive number'
    },
    
    nonNegativeInteger: {
        value: /^(0|[1-9][0-9]*)$/,
        message: 'Enter valid non-negative integer (0 or greater)'
    },
    
    positiveInteger: {
        value: /^[1-9][0-9]*$/,
        message: 'Enter valid positive integer (1 or greater)'
    },
    
    decimal: {
        value: /^[0-9]+(\.[0-9]{1,2})?$/,
        message: 'Enter valid amount (up to 2 decimal places)'
    },
    
    decimalUpTo2: {
        value: /^(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/,
        message: 'Enter valid number with up to 2 decimal places'
    },
    
    decimalUpTo3: {
        value: /^(0|[1-9][0-9]*)(\.[0-9]{1,3})?$/,
        message: 'Enter valid number with up to 3 decimal places'
    },
    
    percentage: {
        value: /^(100(\.0{1,2})?|[1-9]?[0-9](\.[0-9]{1,2})?)$/,
        message: 'Enter valid percentage (0-100)'
    },
    
    // ========================================
    // URL & WEBSITE
    // ========================================
    website: {
        value: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
        message: 'Enter valid website URL'
    },
    
    // ========================================
    // DATE VALIDATIONS (DD/MM/YYYY format)
    // ========================================
    dateFormat: {
        value: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/,
        message: 'Enter date in DD/MM/YYYY format'
    },
    
    // ========================================
    // SPECIAL FORMATS
    // ========================================
    alphanumeric: {
        value: /^[a-zA-Z0-9]+$/,
        message: 'Enter alphanumeric characters only'
    },
    
    noSpecialChars: {
        value: /^[a-zA-Z0-9\s]+$/,
        message: 'Special characters not allowed'
    },
    
    // ========================================
    // PASSWORD VALIDATIONS
    // ========================================
    strongPassword: {
        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
        message: 'Password must contain at least 8 characters with uppercase, lowercase, number and special character'
    },
    
    simplePassword: {
        value: /^.{6,}$/,
        message: 'Password must be at least 6 characters long'
    }
};